import * as React from "react";

export function UpdateSuccess(component: React.Component<any, WizardState<any>>, success: boolean, errors?: string[]) {
    component.setState(() => {
        return { success: success, errors: errors };
    });
}

export function UpdateValue<T>(component: React.Component<any, T>, name: string, value?: string | boolean) {
    component.setState( (state) => {
        // @ts-ignore
        state.form_values[name] = value;
        return state;
    })
}

export function TriggerValidation(component: any, fields: string[], required: any, form_values: any) : boolean {
    for (const field_name in required) {
        if (fields.indexOf(field_name) === -1) {
            continue;
        }

        const result = TriggerValidationSingle(form_values[field_name], required[field_name]);
        if (!result) {
            component.setState({
                validation_triggered: true
            });

            return false;
        }
    }

    return true;
}

export function TriggerValidationSingle(value: string, validations: boolean | string[] | null | undefined) : boolean {
    if (validations === null || validations === undefined || validations === false) {
        return true;
    }

    if (validations === true) {
        validations = ["required"];
    }

    for (let field of validations) {
        switch (field) {
            case "required":
                if (!value || !value.toString().trim()) {
                    return false;
                }
                break;
            case "boolean_required":
                if (!value || !value.toString().trim() || value === "false") {
                    return false;
                }
                break;
            case "email":
                const email_value = value ? value.toString().trim() : "";
                const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (email_value && !email_regex.test(email_value)) {
                    return false;
                }
                break;
        }
    }

    return true;
}

declare global {
    interface Window { dataLayer: any[] | undefined; }
}

export function PushDataLayerEvent(data: any)
{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}